function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { SvgIcon } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
var User = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx(SvgIcon, _extends({
    "data-testid": "UserIcon"
  }, props, {
    ref: ref,
    children: /*#__PURE__*/_jsx("path", {
      d: "M16.5 7.468C16.5 5 14.485 3 12 3S7.5 5 7.5 7.468c0 2.467 2.015 4.468 4.5 4.468s4.5-2 4.5-4.468zM7.263 13.42c.71-.179 1.421.155 2.004.598a4.5 4.5 0 0 0 2.733.918c1.03 0 1.98-.344 2.739-.923.581-.443 1.291-.777 2-.601 3.558.882 4.261 2.847 4.261 4.69V22H3v-3.899c0-1.851.764-3.798 4.263-4.68z"
    })
  }));
});
User.displayName = 'UserIcon';
export default User;